import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const groupLinkTranslationsRef = createTranslationRef({
  id: 'group-links',
  messages: {
    paneTitle: 'Links',
    noLinksText:
      'No links defined for this group. You can add links with the GroupLinks kind and reference this Group name as shown in the highlighted example below:',
  },
});
